import { UserInfo } from '@microsoft/teamsfx';

import { AppError } from 'src/errors';
import { ErrorCodes } from 'src/utils/enums';
import { ERROR_MESSAGES } from 'src/utils/constants';

type UnhandledPromiseErrorConstructorParams = {
  reason: unknown
  user?: UserInfo | null
  context?: Record<string, unknown>
};
export class UnhandledPromiseError extends AppError {
  constructor({ reason, user, context }: UnhandledPromiseErrorConstructorParams) {
    super(
      {
        name: 'UnhandledPromiseError',
        message: reason instanceof Error ? reason.message : ERROR_MESSAGES.unhandledPromiseRejection(String(reason)),
        errorCode: ErrorCodes.UNHANDLED_PROMISE,
        user,
        originalError: reason instanceof Error ? reason : undefined,
        context,
      },
    );

    if (reason instanceof Error && reason.stack) {
      this.stack = reason.stack;
    }
  }
}

export function handleUnhandledPromiseError(event: PromiseRejectionEvent, user?: UserInfo | null): void {
  const errorInstance = new UnhandledPromiseError({ reason: event.reason, user });

  errorInstance.logError();
}
